import { render, staticRenderFns } from "./AuctionPrivateViewingDates.vue?vue&type=template&id=20b4c81c&scoped=true&"
import script from "./AuctionPrivateViewingDates.vue?vue&type=script&lang=js&"
export * from "./AuctionPrivateViewingDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b4c81c",
  null
  
)

export default component.exports